import React from 'react';
import PropTypes from 'prop-types'
import { getRandkey } from '../../../utils/helpers';

export const ImagesRotator = ({
  images,
  className,
  ...otherProps
}) => {
  return (
    <div className={`mz-images-rotator ${className}`} {...otherProps}>
        <div className="mz-images-rotator-inner">
          <div className="mz-images-rotator-content">
            {
              images.map(image => {
                return (
                  <img
                    src={image.src}
                    data-src={image.lowResSrc ? image.lowResSrc : undefined}
                    className={image.lowResSrc ? 'lazy' : ''}
                    key={getRandkey()}
                  />
                )
              })
            }
          </div>
        </div>
    </div>
  )
}

ImagesRotator.propTypes = {
  images: PropTypes.array.isRequired,
  className: PropTypes.string,
}

ImagesRotator.defaultProps = {
  className: '',
  images: [],
}



export default ImagesRotator;